export default __webpack_public_path__ + "static/store-db64160648e2fab6be9af490d262cf04.png";